import { HTMLAttributes, PropsWithChildren } from 'react'
import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from 'components/FirstTimeExperienceModal/components/Table/Table.module.scss'

export const Root = ({ children, ...domProps }: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
  return (
    <div className={Styles.root} {...domProps} role="table">
      {children}
    </div>
  )
}

export const Body = ({ children, ...domProps }: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
  return (
    <div className={Styles.body} {...domProps}>
      {children}
    </div>
  )
}

export const Row = ({ children, ...domProps }: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
  return (
    <div className={Styles.row} {...domProps} role="row">
      {children}
    </div>
  )
}

export const Cell = ({ children, ...domProps }: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
  return (
    <div className={Styles.cell} {...domProps} role="cell">
      {children}
    </div>
  )
}

export const HeaderCell = ({ children, ...domProps }: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
  return (
    <div className={Styles.headerCell} {...domProps} role="cell">
      <Heading level={5}>{children}</Heading>
    </div>
  )
}

export const Table = {
  Root,
  Body,
  Row,
  Cell,
  HeaderCell,
}
